module.exports = __webpack_public_path__ + "static/img/3.021f52d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/cpxh/3.jpg
// module id = EC+T
// module chunks = 0